export default "__VITE_ASSET__18csAkF7__"